"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
var _notice = require("@/api/basic/notice");
var _couponExpand = require("@/api/activity/couponExpand");
var _taskConfig = require("@/api/taskConfig/taskConfig.js");
var _thirdSam = _interopRequireDefault(require("@/api/activity/thirdSam.js"));
var _upgradeStrategy = require("@/api/basic/upgradeStrategy");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 你要根据接口路径改
var _default = exports.default = {
  name: 'ExpandAdd',
  emits: ['saved'],
  props: {
    actId: {
      type: String,
      default: ''
    }
  },
  watch: {
    actId: {
      immediate: true,
      handler: function handler(newId, oldId) {
        console.log('newId', newId, oldId);
        // 避免初始化时的不必要调用
        if (newId && newId != '' && newId != 'null') {
          this.fetchActDetail(newId);
        }
        ;
        console.log('actId', newId);
      }
    }
  },
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH,
      loading: false,
      // 控制 v-loading 显示隐藏

      fileList: [],
      time: [],
      form: {
        productName: '',
        type: '',
        details: [{
          couponId: '',
          quantity: '',
          dailyStockLimit: '',
          totalStock: '',
          bPrice: '',
          oPrice: '',
          cPrice: ''
        }],
        mappingCode: '',
        status: 1
      },
      rules: {
        productName: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择渠道',
          trigger: 'change'
        }],
        mappingCode: [{
          required: true,
          message: '请输入映射编码',
          trigger: 'blur'
        }]
      },
      couponOptions1: [],
      couponLoading: false
    };
  },
  mounted: function mounted() {
    this.getResPathInfo();
  },
  methods: {
    changeType: function changeType(value) {
      console.log('changeType', value);
      if (value == 1) {
        this.form.details[0].quantity = 1;
        this.form.details.length = 1;
      }
    },
    getResPathInfo: function getResPathInfo() {
      var _this = this;
      (0, _upgradeStrategy.getResPath)().then(function (res) {
        _this.resPath = res.data;
      });
    },
    handleAdd: function handleAdd() {
      console.log('handleAdd');
      this.form.details.push({
        couponId: '',
        quantity: '',
        dailyStockLimit: '',
        totalStock: '',
        bPrice: '',
        oPrice: '',
        cPrice: ''
      });
    },
    handleReduce: function handleReduce(index) {
      if (this.form.details.length > 1) {
        this.form.details.splice(index, 1);
      } else {
        this.$message.warning('至少保留一项优惠券组合');
      }
    },
    pad: function pad(n) {
      return n.toString().padStart(2, '0');
    },
    // 获取任务详细信息
    fetchActDetail: function fetchActDetail(id) {
      var _this2 = this;
      console.log('fetchActDetail id', this.storeList);
      var id2 = id;
      if (id.endsWith('_copy')) {
        id2 = id.replace('_copy', '');
      }
      _thirdSam.default.getDetail(id2).then(function (res) {
        if (!res) return;
        if (id.endsWith('_copy')) {
          res.id = null; // 新增复制时，ID 置空
        }
        _this2.form = res; // 假设返回的数据结构是 { data: {...} }

        var promises = _this2.form.details.map(function (item) {
          return (0, _couponExpand.getCouponByThirdId)(item.couponId).then(function (response) {
            response.data.thirdCouponId = Number(response.data.thirdCouponId);
            // 不要赋值 push 的返回值，直接 push 到数组或返回数据由 Promise.all 统一赋值
            _this2.$set(item, 'couponName', response.data.typeName || '');
            return response.data;
          }).catch(function (error) {
            console.error('获取失败:', error);
            return null;
          });
        });
        Promise.all(promises).then(function (results) {
          // 过滤掉失败的 null，然后整体替换 couponOptions1
          _this2.couponOptions1 = results.filter(function (r) {
            return r;
          });
          console.log('couponOptions12', _this2.couponOptions1);
        });
        console.log(" res", res);
      });
    },
    fetchCoupons1: function fetchCoupons1(query) {
      var _this3 = this;
      this.couponLoading = true;
      var params = {
        page: 1,
        limit: 9999,
        typeName: query || '' // ✅ 关键点：从输入框获取模糊搜索的关键字
      };
      (0, _taskConfig.getBonusTypes)(params).then(function (res) {
        _this3.couponOptions1 = res.records || [];
      }).finally(function () {
        _this3.couponLoading = false;
      });
    },
    handleCustomUpload: function handleCustomUpload(_ref) {
      var _this4 = this;
      var file = _ref.file;
      var formData = new FormData();
      formData.append('file', file);
      formData.append('path', "/couponCode/");
      (0, _notice.uploadPhoto)(formData).then(function (res) {
        var url = _this4.resPath + res.data; // 按实际调整
        console.log('上传结果', url);
        // 更新展示地址
        _this4.form.coverImage = url;

        // 替换上传组件的 fileList（最多一张）
        _this4.fileList = [{
          name: '封面图',
          url: url
        }];
        _this4.$message.success('上传成功');
      });
    },
    handleUploadRemove: function handleUploadRemove(index) {
      this.fileList = [];
      this.form.coverImage = '';
    },
    handleSubmit: function handleSubmit() {
      var _this5 = this;
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var i, item, idx, qty, dailyStockLimit, totalStock, bPrice, bpriceRe, oPrice, priceRe, cPrice, formData;
          return regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                console.log('formData', _this5.form);
                if (valid) {
                  _context.next = 1;
                  break;
                }
                _this5.loading = false; // 停止加载
                return _context.abrupt("return");
              case 1:
                i = 0;
              case 2:
                if (!(i < _this5.form.details.length)) {
                  _context.next = 10;
                  break;
                }
                item = _this5.form.details[i];
                idx = i + 1;
                if (!(!item.couponId && !item.couponName)) {
                  _context.next = 3;
                  break;
                }
                // 如果是已保存状态 couponName 也可能存在
                _this5.$message.error("\u8BF7\u4E3A\u7B2C ".concat(idx, " \u9879\u9009\u62E9\u4F18\u60E0\u5238"));
                return _context.abrupt("return");
              case 3:
                qty = String(item.quantity || '').trim();
                if (/^[1-9]\d*$/.test(qty)) {
                  _context.next = 4;
                  break;
                }
                _this5.$message.error("\u8BF7\u4E3A\u7B2C ".concat(idx, " \u9879\u586B\u5199\u6B63\u786E\u7684\u6570\u91CF\uFF08\u6B63\u6574\u6570\uFF09"));
                return _context.abrupt("return");
              case 4:
                dailyStockLimit = String(item.dailyStockLimit || '').trim();
                if (/^[1-9]\d*$/.test(dailyStockLimit)) {
                  _context.next = 5;
                  break;
                }
                _this5.$message.error("\u8BF7\u4E3A\u7B2C ".concat(idx, " \u9879\u586B\u5199\u6B63\u786E\u7684\u6BCF\u65E5\u4E0A\u9650\u5E93\u5B58\uFF08\u6B63\u6574\u6570\uFF09"));
                return _context.abrupt("return");
              case 5:
                totalStock = String(item.totalStock || '').trim();
                if (/^[1-9]\d*$/.test(totalStock)) {
                  _context.next = 6;
                  break;
                }
                _this5.$message.error("\u8BF7\u4E3A\u7B2C ".concat(idx, " \u9879\u586B\u5199\u6B63\u786E\u7684\u603B\u5E93\u5B58\uFF08\u6B63\u6574\u6570\uFF09"));
                return _context.abrupt("return");
              case 6:
                bPrice = String(item.bPrice || '').trim();
                bpriceRe = /^(?!0+(\.0+)?$)\d+(\.\d{1,2})?$/;
                if (bpriceRe.test(bPrice)) {
                  _context.next = 7;
                  break;
                }
                _this5.$message.error("\u8BF7\u4E3A\u7B2C ".concat(idx, " \u9879\u586B\u5199\u6B63\u786E\u7684\u539F\u4EF7\uFF08\u6700\u591A\u4E24\u4F4D\u5C0F\u6570\uFF0C\u4E14\u5927\u4E8E 0\uFF09"));
                return _context.abrupt("return");
              case 7:
                oPrice = String(item.oPrice || '').trim(); // 正数，允许小数，最多两位小数，且不能全为 0（即必须大于 0）
                priceRe = /^(?!0+(\.0+)?$)\d+(\.\d{1,2})?$/;
                if (priceRe.test(oPrice)) {
                  _context.next = 8;
                  break;
                }
                _this5.$message.error("\u8BF7\u4E3A\u7B2C ".concat(idx, " \u9879\u586B\u5199\u6B63\u786E\u7684\u539F\u4EF7\uFF08\u6700\u591A\u4E24\u4F4D\u5C0F\u6570\uFF0C\u4E14\u5927\u4E8E 0\uFF09"));
                return _context.abrupt("return");
              case 8:
                cPrice = String(item.cPrice || '').trim();
                if (priceRe.test(cPrice)) {
                  _context.next = 9;
                  break;
                }
                _this5.$message.error("\u8BF7\u4E3A\u7B2C ".concat(idx, " \u9879\u586B\u5199\u6B63\u786E\u7684C\u7AEF\u9500\u552E\u4EF7\uFF08\u6700\u591A\u4E24\u4F4D\u5C0F\u6570\uFF0C\u4E14\u5927\u4E8E 0\uFF09"));
                return _context.abrupt("return");
              case 9:
                i++;
                _context.next = 2;
                break;
              case 10:
                formData = _this5.form;
                formData.details.forEach(function (item, index) {
                  item.sort = index + 1;
                  item.quantity = Number(item.quantity);
                  item.dailyStockLimit = Number(item.dailyStockLimit);
                  item.totalStock = Number(item.totalStock);
                  item.bPrice = Number(item.bPrice);
                  item.oPrice = Number(item.oPrice);
                  item.cPrice = Number(item.cPrice);
                  delete item.couponName;
                });
                console.log('formData', formData);
                _this5.loading = true; // 开始加载

                _thirdSam.default.addProduct(formData).then(function (res) {
                  if (res.code === 200) {
                    _this5.loading = false; // 停止加载
                    _this5.$message.success('操作成功');
                    _this5.handleClose();
                  } else {
                    _this5.loading = false; // 停止加载
                    _this5.$message.error(res.message);
                  }
                });
              case 11:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    handleClose: function handleClose() {
      this.$emit('saved'); // 通知父组件刷新列表
    }
  }
};